import React from "react";
import "./Footer.css";
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Facebook from "@iconscout/react-unicons/icons/uil-linkedin";
import Gitub from "@iconscout/react-unicons/icons/uil-github";
import Twitter from "@iconscout/react-unicons/icons/uil-twitter";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="f-content">
        <div>
          <span>Ready to build something sharp?</span>
          <a href="mailto:sicelositsha@yahoo.com">sicelositsha@yahoo.com</a>
        </div>
        <div className="f-icons">
          <a href="https://www.instagram.com/i.am.sicelo/" aria-label="Instagram">
            <Insta color="currentColor" size={"1.5rem"} />
          </a>
          <a href="https://www.linkedin.com/in/sicelositsha/" aria-label="LinkedIn">
            <Facebook color="currentColor" size={"1.5rem"} />
          </a>
          <a href="https://github.com/sicelo17/" aria-label="GitHub">
            <Gitub color="currentColor" size={"1.5rem"} />
          </a>
          <a href="https://twitter.com/sitsha_sicelo" aria-label="Twitter">
            <Twitter color="currentColor" size={"1.5rem"} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
